"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
const factureForm_1 = require("./facturation/factureForm");
const aide_1 = require("views/aide");
// let formatModeReglement = [
// 	_("1 ligne"),
// 	_("2 lignes"),
// 	_("3 lignes")
// ];
class DataFactures extends webix_jet_1.JetView {
    config() {
        return {
            rows: [
                { cols: [
                        { template: (0, globals_1._)("Informations Factures / Devis"), css: "webix_header app_header", height: 38, width: 250, "borderless": true },
                        { label: "" },
                        {
                            view: "button", label: (0, globals_1._)("Retour"), localId: "annulerButton", width: 150,
                            click: () => this.annuler()
                        }, {
                            view: "button", label: (0, globals_1._)("Enregistrer"), localId: "enregistrerButton", hidden: true, width: 150,
                            click: () => this.enregistrer()
                        }
                    ] },
                { body: {
                        view: "form", id: "dataFactures",
                        elementsConfig: { maxWidth: 500, labelAlign: "right", labelWidth: 200, height: 32 },
                        elements: [{
                                view: "text", name: "unid", label: (0, globals_1._)("N°"),
                                width: "400", attributes: { maxlength: 40 },
                                editor: "text", hidden: true
                            }, {
                                view: "text", name: "logo", label: (0, globals_1._)("Texte logo"),
                                width: "400", attributes: { maxlength: 40 },
                                editor: "text", tooltip: (0, globals_1._)("Texte de remplacement en cas d'absence de logo")
                            }, {
                                view: "select", name: "formatNumeroFacture", label: (0, globals_1._)("Format N° de facture"),
                                width: "500", options: factureForm_1.formatNumeroFacture,
                                tooltip: (0, globals_1._)("Ne modifiez plus ce format une fois que vous avez commencé à émettre des factures, voir l'aide")
                                // }, {
                                // 	view : "select", name : "modeReglement", label : _("Format mode de règlement"),
                                // 	width : "400", options : formatModeReglement, editor : ""
                            }, {
                                view: "label", label: (0, globals_1._)("Conditions de règlement"), labelAlign: "left", labelWidth: 300
                            }, {
                                view: "text", name: "conditionsReglement1",
                                width: "700", attributes: { maxlength: 100 },
                                editor: "text"
                            }, {
                                view: "text", name: "conditionsReglement2", label: (0, globals_1._)(""),
                                width: "700", attributes: { maxlength: 100 },
                                editor: "text"
                            }, {
                                view: "text", name: "conditionsReglement3", label: (0, globals_1._)(""),
                                width: "700", attributes: { maxlength: 100 },
                                editor: "text"
                            }, {
                                view: "label", label: (0, globals_1._)("Mentions obligatoires"), labelAlign: "left", labelWidth: 300
                            }, {
                                view: "text", name: "mentionObligatoire1", label: (0, globals_1._)(""),
                                width: "700", attributes: { maxlength: 100 },
                                editor: "text"
                            }, {
                                view: "text", name: "mentionObligatoire2", label: (0, globals_1._)(""),
                                width: "700", attributes: { maxlength: 100 }, editor: "text"
                            }, {
                                view: "text", name: "mentionObligatoire3", label: (0, globals_1._)(""),
                                width: "700", attributes: { maxlength: 100 }, editor: "text"
                            }, {
                                view: "label", label: (0, globals_1._)("Références bancaires"), labelAlign: "left", labelWidth: 300
                            }, {
                                view: "text", name: "banque", label: (0, globals_1._)(""),
                                width: "700", attributes: { maxlength: 100 }, editor: "text"
                            }, {
                                // 	view : "text", localId : "numeroChrono", name : "numeroChrono", label : _("Dernier N° de facture utilisé"),
                                // 	labelwidth : 350, labelAlign : "left", inputAlign : "right",
                                // 	width : "300", attributes : {maxlength : 10}, editor : "text",
                                // 	tooltip : _("ATTENTION, référez vous aux conseils de configuration pour modifier cette donnée")
                                // }, {
                                template: "", fillspace: true, height: 1
                            }],
                        rules: {
                        // "email" : webix.rules.isEmail
                        }
                    }
                },
                {} // pour que le menu occupe la totalité de la hauteur
            ]
        };
    }
    getAide() {
        let aide = this.ui(aide_1.default);
        // aide.showHelp();
    }
    annuler() {
        history.back();
    }
    enregistrer() {
        let vv = $$("dataFactures");
        if (vv.validate()) {
            let me = this;
            let values = vv.getValues();
            let zz = JSON.stringify(values);
            let xx = { "cle": "factures.data", "texte": zz };
            // @ts-ignore
            let promise = webix.ajax().post(globals_1.phpPath + "parametres.php?option=savejson", xx);
            promise.then(function (result) {
                if (result.json().success == false) {
                    webix.alert(result.json().message);
                    return;
                }
                webix.message("Données enregistrées");
                // @ts-ignore
                me.getRoot().close();
            });
            promise.catch(function () {
                webix.alert((0, globals_1._)("Erreur d'enregistrement des données factures"));
                // @ts-ignore
                me.getRoot().close();
            });
        }
    }
    showWindow() {
        // @ts-ignore
        this.getRoot().show();
    }
    init() {
        let me = this;
        this.moduleName = "dataFactures";
        let vv = $$("dataFactures");
        vv.load(globals_1.phpPath + "parametres.php?key=factures.data&option=readjson");
        // lecture du N° chrono et insertion dans les données du masque
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "stddata.php?tname=parametres&option=read&cle=chronoFactures");
        promise.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            let num = parseInt(result.json().valeur);
            let numeroChronoField = $$("numeroChrono");
            numeroChronoField.setValue(String(num));
        });
        if ((globals_1.lv2.droits).includes("parametres.savejson.entreprise")) { // @ts-ignore
            this.$$("enregistrerButton").show();
        }
    }
}
exports.default = DataFactures;
